import { render, staticRenderFns } from "./do-not-disturb-form.vue?vue&type=template&id=4b2396bb&"
import script from "./do-not-disturb-form.vue?vue&type=script&lang=js&"
export * from "./do-not-disturb-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports